module.exports = __webpack_public_path__ + "fonts/OpenSans-BoldItalic.27cc80e6.woff";